module.exports = __webpack_public_path__ + "static/media/arrowCardRight.5abaff19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrowCardRight.svg
// module id = 50
// module chunks = 0